import useProfile from "api/UserResource/useProfile";
import useAuthStore from "store/authStore";
import UpdatePublisher from "./UpdatePublisher";
import { Role } from "utils/server-constants/roles";
import AccountPage from "../AccountPage";
import AccountLayout from "../AccountLayout";

const PublisherDetails = () => {
	const { hasRoles } = useAuthStore();

	const { data: profile, isLoading: isLoadingProfile } = useProfile();

	return (
		<AccountPage>
			<AccountLayout isLoading={isLoadingProfile} profile={profile?.data}>
				<div className="space-y-4" style={{ maxWidth: 500 }}>
					<div>
						{hasRoles([Role.SeniorPublisher]) ? (
							<UpdatePublisher
								publisherId={profile?.data?.publishers?.[0]?.id}
								name={profile?.data?.publishers?.[0]?.name}
								physicalAddress={profile?.data?.publishers?.[0]?.physical_address}
								focusArea={profile?.data?.publishers?.[0]?.focus_area}
								country={profile?.data?.publishers?.[0]?.country}
							/>
						) : (
							<p className="text-sm leading-relaxed text-gray-600">
								Only a Senior Publisher can update the publishing house profile. Contact your Senior
								Publisher if it still needs to be completed.
							</p>
						)}
					</div>
				</div>
			</AccountLayout>
		</AccountPage>
	);
};

export default PublisherDetails;
